module.exports = __webpack_public_path__ + "img/2d830ee19d7ffab35fe4d07ac3b8dd49.svg";